import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const PaperAirplane = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      d="M21.7582893,12.0314941L5.7540259,2.0743408C5.6719341,2.0232544,5.5842266,2,5.4988384,2
	C5.2390728,2,4.9999981,2.2150879,4.9999981,2.5170898V12H2.4999998C2.2236326,12,2,12.2236328,2,12.5S2.2236326,13,2.4999998,13
	h2.4999983v8.4830322C4.9999981,21.7834473,5.2378521,22,5.4984112,22c0.0789185,0,0.1599121-0.0198975,0.2369995-0.0632935
	l16.0042629-9.0088501C22.0782967,12.7372437,22.0887337,12.2370605,21.7582893,12.0314941z M5.9999976,3.4051514L19.7499905,12
	H5.9999976V3.4051514z M5.9635291,12.9999704L19.5499897,13L5.9635291,20.6402302V12.9999704z"
    />
  </SvgIcon>
);

export default PaperAirplane;
